module.exports = __webpack_public_path__ + "assets/img/barb_head_shot.9ad5cb2c.png";